import React from "react";
import { Cards } from "./Content/Cards/Cards";
import { Container } from "./Content/Container/Container";
import Slider from "./Content/SliderCont/Slider";
import style from "./Content.module.css";
const Content = () => {
  return (
    <div className={style.container}>
      <Slider></Slider>
      <Container></Container>
    </div>
  );
};

export default Content;
